import { render, staticRenderFns } from "./AlarmPage.vue?vue&type=template&id=a18a9248&scoped=true&"
import script from "./AlarmPage.vue?vue&type=script&lang=js&"
export * from "./AlarmPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18a9248",
  null
  
)

export default component.exports